import {toFullScreen} from "./video-chat/include/full-screen";
import vChatComm from "./vc/src/VChatComm";
import config from "./vc/src/config";
import {isPipSupported, requestPip} from "./video-chat/include/pip";
import {FinalResult, testServer} from "./trickle-ice";

require("./test-requirements.scss");

(async () => {
    const video = document.getElementById("video-h") as HTMLVideoElement;
    video.muted = false;
    video.setAttribute("playsinline", "");
    video.onloadedmetadata = () => {
        video.setAttribute("width", video.videoWidth.toString());
        video.setAttribute("height", video.videoHeight.toString());
    };

    if (!isPipSupported(video)) {
        $(".to-pip-h").hide();
    }

    const videoConstraints = {
        facingMode: {
            ideal: 'user',
        },
        aspectRatio: {
            ideal: 16 / 9,
        },
        width: {
            max: 1920,
            ideal: 1920,
        },
    };

    const $errorMsg = $("#errorMsg") as JQuery<HTMLUListElement>;

    function clearMessages(): void {
        $errorMsg.html("");
    }

    function message(msg: string, color = "green", className: string = ""): JQuery<HTMLUListElement> {
        const li = $(`<li />`, {text: msg, "class": className});
        $errorMsg.append(li.css({color}));

        return li as JQuery<HTMLUListElement>;
    }

    function errorMsg(msg: string): JQuery<HTMLUListElement> {
        return message(msg, "red", "result");
    }

    let connectionError = false;


    vChatComm.onReceive("connect_error", (e: any) => {
        console.error("Connection error", e);
        connectionError = true;
    });

    const btnShow = $("#btnShow");
    btnShow.prop("disabled", true);
    vChatComm.onConnected(() => btnShow.prop("disabled", false));

    vChatComm.onConnectError(() => $(".conn-err-h").show());

    vChatComm.connect();

    await vChatComm.waitForConnection();

    const iceServers: RTCIceServer[] = (await vChatComm.send("get servers")).map(server => {
        if (typeof (server as any).url === "string") {
            return {
                urls: [(server as any).url],
            } as RTCIceServer;
        }

        return server as RTCIceServer;
    });

    console.info("Servers", iceServers);

    const servers: ServerTest[] = iceServers.map(server => {
        const name = (server.urls as string[]).find(url => url.match(/^turns?:/i))
            ? "TURN"
            : "STUN";
        const note: ServerTest["note"] = {
            "Ошибка авторизации": "Ошибка на стороне сервера. Обратитесь к администрации",
        };
        if (name === "TURN") {
            note["Недоступен"] = "Связь всё ещё может быть установлена, если сетевая конфигурация " +
                "одного из собеседников позволяет. " +
                "В ином случае будет доступен только текстовый чат";
        }

        return {name, note, server};
    });

    let micFound = false;

    const tests: Tests = [
        {
            name: "Проверка доступности главного сервера",
            cb: () => {
                if (connectionError) {
                    errorMsg(`Ошибка подключения, пожалуйста, обратитесь в Тех. поддержку.`);
                    console.error(`Произошла ошибка при попытке соединения с ${config.ssUrl}`);
                    return false;
                }
                return true;
            },
        }, {
            name: "Проверка камеры",
            cb: async () => {
                try {
                    const stream = await navigator.mediaDevices.getUserMedia({
                        audio: true,
                        video: videoConstraints
                    });

                    const videoTracks = stream.getVideoTracks();
                    console.info("Got stream with audioConstraints:", {
                        audio: true,
                        video: videoConstraints
                    });
                    console.info(`Using video device: ${videoTracks[0].label}`);
                    video.srcObject = stream;
                    micFound = true;
                } catch (error) {
                    if ((error as any).name === "PermissionDeniedError") {
                        errorMsg("Права доступа на использование камеры " +
                            "и микрофона не были установлены, вы должны разрешить данной " +
                            "странице использовать ваши устройства для дальнейшей работы.");
                        return false;
                    }
                    console.warn(error);

                    message("Попытка получить камеру без микрофона", "orange", "result");

                    try {
                        video.srcObject = await navigator.mediaDevices.getUserMedia({video: videoConstraints});
                    } catch (e) {
                        message("", "black", "result").html(
                            `Не работает камера. Возможные причины:<br />
							1. У вас на устройстве не установлена камера<br />
							2. В настройках браузера не предоставлено разрешение на доступ к камере.<br />
							3. Ваш браузер не поддерживает работу камеры<br />
							Если у вас есть камера и разрешен к ней доступ, попробуйте использовать другой браузер из рекомендованных нами.`,
                        );

                        console.error(e);

                        return false;
                    }
                }

                return true;
            },
        }, {
            name: "Проверка микрофона",
            cb: async () => {
                if (micFound) {
                    return true;
                }

                try {
                    await navigator.mediaDevices.getUserMedia({audio: true});
                } catch (e) {
                    message("", "black", "result").html(
                        `Не работает микрофон. Возможные причины:<br />
							1. У вас на устройстве не установлен микрофон<br />
							2. В настройках браузера не предоставлено разрешение на доступ к микрофону.<br />
							3. Ваш браузер не поддерживает работу микрофона.<br />
							Если у вас есть микрофон и разрешен к нему доступ, попробуйте использовать другой браузер из рекомендованных нами.`,
                    );

                    console.error(e);

                    return false;
                }

                return true;
            },
        }, {
            name: "Проверка доступности коммуникационных серверов",
            cb: async () => {
                if (servers.length <= 0) {
                    errorMsg("Не получено ни одного сервера");
                    return false;
                }

                let atLeastOneSuccess = false;
                let atLeastOneError = false;

                const sp = [];
                let counter = 0;
                for (const server of servers) {
                    sp.push(await (async () => {
                        const chkMsg = message(`Проверка доступности сервера №${++counter} (${server.name})`, "black");
                        const msg = message("Проверка…", "orange", "result");
                        const result = await testServer(server.server);

                        let resMsg;
                        let addMsg;
                        if (result.isError) {
                            atLeastOneError = true;
                            console.error(result);
                            if (typeof (window as any).__err_send === "function") {
                                (window as any).__err_send(result.context);
                            }
                            resMsg = errorMsg(result.msg);
                            addMsg = server.note[result.msg as FinalResult];
                            if (addMsg) {
                                message(addMsg, "orange", "result");
                            }
                        } else {
                            atLeastOneSuccess = true;
                            resMsg = message(result.msg, "green", "result");
                        }

                        resMsg.insertAfter(chkMsg);
                        msg.remove();
                    })());
                }

                message("Ожидание завершения проверки серверов", "black");

                await Promise.all(sp);

                if (!atLeastOneSuccess) {
                    errorMsg("Ни один из серверов не доступен");
                }

                if (atLeastOneError) {
                    message("Возможно, видео-связь не будет работать корректно. Советуем сменить устройство " +
                        "или подключение к интернет. Или обратиться техническую поддержку нашего сервиса.", "black");
                }

                return atLeastOneSuccess;
            },
        }, {
            name: "Завершение тестирования",
            cb: () => true,
        },
    ];

    let opened: boolean | undefined;

    $("body")
        .on("click", "#btnShow", async e => {
            const show = $("#show");
            const button = $(e.target);
            button.text("Прервать проверку");

            if (!opened) {
                clearMessages();
                show.show();
                opened = true;

                console.group("%c[Test Runner] Started", "color: blue; font-weight: bold;");
                for (const test of tests) {
                    console.group(`%c[Test Runner] Step: ${test.name}`, 'color: #2980b9; font-weight: bold;');
                    
                    if (test.name === "Проверка доступности главного сервера") {
                        console.info(`Attempting to connect to Signal Server: ${config.ssUrl}`);
                        console.info(`Connection Status: ${vChatComm.sessionId ? 'Connected (' + vChatComm.sessionId + ')' : 'Connecting...'}`);
                    }

                    if (test.name === "Проверка доступности коммуникационных серверов") {
                        console.info("ICE Servers received for testing:", iceServers);
                    }

                    message(test.name, "black");
                    let passed = false;
                    try {
                        passed = await test.cb();
                    } catch (e) {
                        console.error(`[Test Runner] Critical exception in ${test.name}:`, e);
                        errorMsg("Произошла неизвестная ошибка");
                    }
                    
                    if (passed) {
                        console.info(`%c[Test Runner] SUCCESS: ${test.name}`, 'color: green;');
                        message("Успешно", "green", "result");
                    } else {
                        console.warn(`%c[Test Runner] FAILED: ${test.name}`, 'color: red;');
                        console.groupEnd(); // Закрываем группу текущего шага
                        break;
                    }
                    console.groupEnd(); // Закрываем группу текущего шага
                }
                console.groupEnd(); // Закрываем общую группу

                button.text("Скрыть");
            } else if (opened) {
                show.hide();
                button.text("Перепроверить");
                opened = false;
                let stream = video.srcObject as MediaStream | null;
                if (stream) {
                    video.pause();
                    video.srcObject = null;
                    for (const track of stream.getTracks()) {
                        track.stop();
                    }
                    stream = null;
                }
            }
        })
        .on("click", ".to-fc-h", () => toFullScreen($(".video-container-h").get(0), video))
        .on("click", ".to-pip-h", () => {
            if (!isPipSupported(video)) {
                alert("Программный переход в режим картинка-в-картине не поддерживается на даном устройстве. " +
                    "Возможно, устройство предоставляет собственный способ перехода в этот режим.");
                return false;
            }

            requestPip(video).catch(e => console.error(e));
        });
})();

type TestCallback = () => boolean | Promise<boolean>

interface Test {
    name: string;
    cb: TestCallback;
}

type Tests = Test[]

type ServerTest = {
    server: RTCIceServer,
    name: string;
    note: Partial<Record<FinalResult, string>>
}
